/**
 * Página de Detalhes do Cliente
 */

import React from 'react';
import { Layout } from '@components';
import ListaClienteDetalhe from '../components/cliente/ListaClienteDetalhe';

const ListaClienteDetalhePage: React.FC = () => {
  return (
    <Layout title="Detalhes do Cliente" showHeader showFooter footerType="cliente">
      <ListaClienteDetalhe />
    </Layout>
  );
};

export default ListaClienteDetalhePage;
